import { normalize } from 'normalizr';

import * as partSchema from 'store/part/schema';
import * as schema from 'store/quotes/schema';

import { notify } from 'utils/reduxUtils';

export const types = {
  ACKNOWLEDGE_FORCE_SCROLL_TO_COMPONENT_ROW:
    'quotes/quoteItemComponents/ACKNOWLEDGE_FORCE_SCROLL_TO_COMPONENT_ROW',

  ATTACH_FILES_ERROR: 'quotes/quoteItemComponents/ATTACH_FILES_ERROR',
  ATTACH_FILES_CANCEL: 'quotes/quoteItemComponents/ATTACH_FILES_CANCEL',
  ATTACH_FILES_REQUEST: 'quotes/quoteItemComponents/ATTACH_FILES_REQUEST',
  ATTACH_FILES_SUCCESS: 'quotes/quoteItemComponents/ATTACH_FILES_SUCCESS',

  BULK_COMPONENT_UPDATE_ERROR:
    'quotes/quoteItemComponents/BULK_COMPONENT_UPDATE_ERROR',
  BULK_COMPONENT_UPDATE_REQUEST:
    'quotes/quoteItemComponents/BULK_COMPONENT_UPDATE_REQUEST',
  BULK_COMPONENT_UPDATE_SUCCESS:
    'quotes/quoteItemComponents/BULK_COMPONENT_UPDATE_SUCCESS',

  COLLAPSE_COMPONENT: 'quotes/quoteItemComponents/COLLAPSE_COMPONENT',

  COMPONENT_INTERROGATION_ERROR:
    'quotes/quoteItemComponents/COMPONENT_INTERROGATION_ERROR',
  COMPONENT_INTERROGATION_REQUEST:
    'quotes/quoteItemComponents/COMPONENT_INTERROGATION_REQUEST',
  COMPONENT_INTERROGATION_SUCCESS:
    'quotes/quoteItemComponents/COMPONENT_INTERROGATION_SUCCESS',

  COMPONENT_TABLE_STATE_MERGE:
    'quotes/quoteItemComponents/COMPONENT_TABLE_STATE_MERGE',

  DELETE_COMPONENTS_ERROR: 'quotes/quoteItemComponents/DELETE_COMPONENTS_ERROR',
  DELETE_COMPONENTS_REQUEST:
    'quotes/quoteItemComponents/DELETE_COMPONENTS_REQUEST',
  DELETE_COMPONENTS_SUCCESS:
    'quotes/quoteItemComponents/DELETE_COMPONENTS_SUCCESS',

  EDIT_CONTOUR_REQUEST: 'quotes/quoteItemComponents/EDIT_CONTOUR_REQUEST',
  EDIT_CONTOUR_SUCCESS: 'quotes/quoteItemComponents/EDIT_CONTOUR_SUCCESS',
  EDIT_CONTOUR_ERROR: 'quotes/quoteItemComponents/EDIT_CONTOUR_ERROR',

  EDIT_UNITS_ERROR: 'quotes/quoteItemComponents/EDIT_UNITS_ERROR',
  EDIT_UNITS_REQUEST: 'quotes/quoteItemComponents/EDIT_UNITS_REQUEST',
  EDIT_UNITS_SUCCESS: 'quotes/quoteItemComponents/EDIT_UNITS_SUCCESS',

  EXPAND_COMPONENT_CLEAR: 'quotes/quoteItemComponents/EXPAND_COMPONENT_CLEAR',
  EXPAND_COMPONENT_REQUEST:
    'quotes/quoteItemComponents/EXPAND_COMPONENT_REQUEST',
  EXPAND_COMPONENT_SUCCESS:
    'quotes/quoteItemComponents/EXPAND_COMPONENT_SUCCESS',
  EXPAND_COMPONENT_ERROR: 'quotes/quoteItemComponents/EXPAND_COMPONENT_ERROR',

  ON_BOM_RESTRUCTURE: 'quotes/quoteItemComponents/ON_BOM_RESTRUCTURE',

  PAGE_VECTORIZATION_REQUEST:
    'quotes/quoteItemComponents/PAGE_VECTORIZATION_REQUEST',
  PAGE_VECTORIZATION_SUCCESS:
    'quotes/quoteItemComponents/PAGE_VECTORIZATION_SUCCESS',
  PAGE_VECTORIZATION_ERROR:
    'quotes/quoteItemComponents/PAGE_VECTORIZATION_ERROR',

  REMOVE_ATTACHED_FILE_REQUEST:
    'quotes/quoteItemComponents/REMOVE_ATTACHED_FILE_REQUEST',
  REMOVE_ATTACHED_FILE_SUCCESS:
    'quotes/quoteItemComponents/REMOVE_ATTACHED_FILE_SUCCESS',
  REMOVE_ATTACHED_FILE_ERROR:
    'quotes/quoteItemComponents/REMOVE_ATTACHED_FILE_ERROR',

  SELECT_COMPONENT_DESELECT_ALL:
    'quotes/quoteItemComponents/SELECT_COMPONENT_DESELECT_ALL',
  SELECT_COMPONENT_DESELECT_BULK:
    'quotes/quoteItemComponents/SELECT_COMPONENT_DESELECT_BULK',
  SELECT_COMPONENT_MERGE_SELECTION:
    'quotes/quoteItemComponents/SELECT_COMPONENT_MERGE_SELECTION',
  SELECT_COMPONENT_SELECT: 'quotes/quoteItemComponents/SELECT_COMPONENT_SELECT',

  SET_COMPONENT_NODE_QUANTITY_REQUEST:
    'quotes/quoteItemComponents/SET_COMPONENT_NODE_QUANTITY_REQUEST',
  SET_COMPONENT_NODE_QUANTITY_ERROR:
    'quotes/quoteItemComponents/SET_COMPONENT_NODE_QUANTITY_ERROR',

  OPEN_POP_OUT_VIEWER: 'quotes/quoteItemComponents/OPEN_POP_OUT_VIEWER',

  OPEN_VECTOR_FILE_EDITOR: 'quotes/quoteItemComponents/OPEN_VECTOR_FILE_EDITOR',
  OPEN_VECTOR_EDITOR: 'quotes/quoteItemComponents/OPEN_VECTOR_EDITOR',

  UPLOAD_COMPONENT_REQUEST: 'quote/components/UPLOAD_COMPONENT_REQUEST',
  UPLOAD_COMPONENT_SUCCESS: 'quote/components/UPLOAD_COMPONENT_SUCCESS',
  UPLOAD_COMPONENT_ERROR: 'quote/components/UPLOAD_COMPONENT_ERROR',

  CREATE_MANUFACTURED_COMPONENT_REQUEST:
    'quote/components/CREATE_MANUFACTURED_COMPONENT_REQUEST',
  CREATE_MANUFACTURED_COMPONENT_SUCCESS:
    'quote/components/CREATE_MANUFACTURED_COMPONENT_SUCCESS',
  CREATE_MANUFACTURED_COMPONENT_ERROR:
    'quote/components/CREATE_MANUFACTURED_COMPONENT_ERROR',

  CONVERT_TO_MANUFACTURED_COMPONENT_REQUEST:
    'quotes/quoteItemComponents/CONVERT_TO_MANUFACTURED_COMPONENT_REQUEST',
  CONVERT_TO_MANUFACTURED_COMPONENT_ERROR:
    'quotes/quoteItemComponents/CONVERT_TO_MANUFACTURED_COMPONENT_ERROR',
  CONVERT_TO_MANUFACTURED_COMPONENT_SUCCESS:
    'quotes/quoteItemComponents/CONVERT_TO_MANUFACTURED_COMPONENT_SUCCESS',

  RECEIVE_QUOTE_ITEM_COMPONENT:
    'quotes/quoteItemComponents/RECEIVE_QUOTE_ITEM_COMPONENT',

  SNAP_TO_COMPONENT_HEADER_REQUEST:
    'quotes/quoteItemComponents/SNAP_TO_COMPONENT_HEADER_REQUEST',

  SWITCH_PRIMARY_FILE_REQUEST:
    'quotes/quoteItemComponents/SWITCH_PRIMARY_FILE_REQUEST',
  SWITCH_PRIMARY_FILE_SUCCESS:
    'quotes/quoteItemComponents/SWITCH_PRIMARY_FILE_SUCCESS',
  SWITCH_PRIMARY_FILE_ERROR:
    'quotes/quoteItemComponents/SWITCH_PRIMARY_FILE_ERROR',

  OPEN_MANAGE_REAL_TIME_PRICING_MODAL:
    'quotes/quoteItemComponents/OPEN_MANAGE_REAL_TIME_PRICING_MODAL',
  CLOSE_MANAGE_REAL_TIME_PRICING_MODAL:
    'quotes/quoteItemComponents/CLOSE_MANAGE_REAL_TIME_PRICING_MODAL',
};

export const manageRealTimePricingModal = {
  open: () => ({
    type: types.OPEN_MANAGE_REAL_TIME_PRICING_MODAL,
  }),
  close: () => ({
    type: types.CLOSE_MANAGE_REAL_TIME_PRICING_MODAL,
  }),
};

export const expandComponent = {
  clear: () => ({
    type: types.EXPAND_COMPONENT_CLEAR,
  }),
  request: ({ componentId, nodeId }) => ({
    type: types.EXPAND_COMPONENT_REQUEST,
    payload: { componentId, nodeId },
  }),
  success: (payload) => ({
    type: types.EXPAND_COMPONENT_SUCCESS,
    payload: {
      componentId: payload.component.id,
      ...normalize(payload.component, schema.quoteItemComponent),
    },
  }),
  error: (payload) => ({
    type: types.EXPAND_COMPONENT_ERROR,
    payload,
  }),
};

export const receiveQuoteItemComponent = ({ quoteItemComponent }) => ({
  type: types.RECEIVE_QUOTE_ITEM_COMPONENT,
  payload: normalize(quoteItemComponent, schema.quoteItemComponent),
});

export const forceScrollToComponentRow = {
  acknowledge: () => ({
    type: types.ACKNOWLEDGE_FORCE_SCROLL_TO_COMPONENT_ROW,
  }),
};

export const collapseComponent = () => ({
  type: types.COLLAPSE_COMPONENT,
});

export const componentInterrogation = {
  request: ({ componentId }) => ({
    type: types.COMPONENT_INTERROGATION_REQUEST,
    payload: { componentId },
  }),
  success: () => ({
    type: types.COMPONENT_INTERROGATION_SUCCESS,
  }),
  error: notify(
    (error) => ({
      type: types.COMPONENT_INTERROGATION_ERROR,
      payload: error,
    }),
    'Failed to interrogate component',
  ),
};

export const editUnits = {
  request: ({ componentId, filename, fileUuid, units }) => ({
    type: types.EDIT_UNITS_REQUEST,
    payload: { componentId, filename, fileUuid, units },
  }),
  success: () => ({
    type: types.EDIT_UNITS_SUCCESS,
  }),
  error: notify(
    (error) => ({
      type: types.EDIT_UNITS_ERROR,
      payload: error,
    }),
    'Failed to edit part',
  ),
};

export const attachFiles = {
  request: ({
    partId,
    quoteItemId,
    orderItemId,
    partMasterVersion,
    files,
    shouldSetPrimaryFile,
  }) => ({
    type: types.ATTACH_FILES_REQUEST,
    payload: {
      partId,
      quoteItemId,
      orderItemId,
      partMasterVersion,
      files,
      shouldSetPrimaryFile,
    },
  }),
  success: (part) => ({
    type: types.ATTACH_FILES_SUCCESS,
    payload: {
      partId: part.uuid,
      ...normalize(part, partSchema.part),
    },
  }),
  cancel: (partId) => ({
    type: types.ATTACH_FILES_CANCEL,
    payload: { partId },
  }),
  error: (partId) => ({
    type: types.ATTACH_FILES_ERROR,
    payload: { partId },
  }),
};

export const removeAttachedFile = {
  request: (partId, quoteItemId, fileId) => ({
    type: types.REMOVE_ATTACHED_FILE_REQUEST,
    payload: { partId, quoteItemId, fileId },
  }),
  success: (part) => ({
    type: types.REMOVE_ATTACHED_FILE_SUCCESS,
    payload: {
      ...normalize(part, partSchema.part),
    },
  }),
  error: (part) => ({
    type: types.REMOVE_ATTACHED_FILE_ERROR,
    payload: {
      ...normalize(part, partSchema.part),
    },
  }),
};

export const selectComponent = {
  deselectAll: () => ({
    type: types.SELECT_COMPONENT_DESELECT_ALL,
  }),
  deselectBulk: ({ components, lastSelection }) => ({
    type: types.SELECT_COMPONENT_DESELECT_BULK,
    payload: { components, lastSelection },
  }),
  mergeSelection: ({ components, lastSelection }) => ({
    type: types.SELECT_COMPONENT_MERGE_SELECTION,
    payload: { components, lastSelection },
  }),
  select: ({ component }) => ({
    type: types.SELECT_COMPONENT_SELECT,
    payload: { component },
  }),
};

export const componentTableState = {
  merge: ({ parentComponentId, state }) => ({
    type: types.COMPONENT_TABLE_STATE_MERGE,
    payload: { parentComponentId, state },
  }),
};

export const deleteComponents = {
  request: ({ componentIds, nodeIds, quoteItemId }) => ({
    type: types.DELETE_COMPONENTS_REQUEST,
    payload: { componentIds, nodeIds, quoteItemId },
  }),
  success: (payload) => ({
    type: types.DELETE_COMPONENTS_SUCCESS,
    payload: {
      ...normalize(payload, schema.quoteItem),
    },
  }),
  error: notify(
    (error) => ({
      type: types.DELETE_COMPONENTS_ERROR,
      payload: error,
    }),
    'Failed to delete components',
  ),
};

/**
 * @deprecated Use `openPopOutViewerFunc` instead.
 */
export const openPopOutViewer = ({
  activePartUuid,
  isMaterialWidgetSelected,
  partMasterUuid,
  partMasterVersion,
  quoteItemId,
  selectedFileUuid,
}) => ({
  type: types.OPEN_POP_OUT_VIEWER,
  payload: {
    activePartUuid,
    isMaterialWidgetSelected,
    partMasterUuid,
    partMasterVersion,
    quoteItemId,
    selectedFileUuid,
  },
});

export const uploadComponent = {
  request: ({ files, quoteItemId, parentComponentId }) => ({
    type: types.UPLOAD_COMPONENT_REQUEST,
    payload: { files, quoteItemId, parentComponentId },
  }),
  success: () => ({
    type: types.UPLOAD_COMPONENT_SUCCESS,
  }),
  error: notify(
    (error) => ({
      type: types.UPLOAD_COMPONENT_ERROR,
      payload: error,
    }),
    'Failed to upload component(s)',
  ),
};

export const setComponentNodeQuantity = {
  request: ({ childComponentId, parentComponentId, quantity }) => ({
    type: types.SET_COMPONENT_NODE_QUANTITY_REQUEST,
    payload: { childComponentId, parentComponentId, quantity },
  }),
  error: notify(
    (error) => ({
      type: types.SET_COMPONENT_NODE_QUANTITY_ERROR,
      payload: error,
    }),
    'Error setting BOM quantity',
  ),
};

export const convertToManufacturedComponent = {
  request: ({ componentId }) => ({
    type: types.CONVERT_TO_MANUFACTURED_COMPONENT_REQUEST,
    payload: { componentId },
  }),
  success: () => ({
    type: types.CONVERT_TO_MANUFACTURED_COMPONENT_SUCCESS,
  }),
  error: notify(
    (error) => ({
      type: types.CONVERT_TO_MANUFACTURED_COMPONENT_ERROR,
      payload: error,
    }),
    'Failed to convert to manufactured component',
  ),
};

export const bulkComponentUpdate = {
  request: ({ componentIds, quoteId }) => ({
    type: types.BULK_COMPONENT_UPDATE_REQUEST,
    payload: { componentIds, quoteId },
  }),
  success: () => ({
    type: types.BULK_COMPONENT_UPDATE_SUCCESS,
  }),
  error: notify(
    (error) => ({
      type: types.BULK_COMPONENT_UPDATE_ERROR,
      payload: error,
    }),
    'Failed to update component(s)',
  ),
};

export const createManufacturedComponent = {
  request: ({ quoteItemId, parentComponentId, mode, isAssembly }) => ({
    type: types.CREATE_MANUFACTURED_COMPONENT_REQUEST,
    payload: { quoteItemId, parentComponentId, mode, isAssembly },
  }),
  success: () => ({
    type: types.CREATE_MANUFACTURED_COMPONENT_SUCCESS,
  }),
  error: notify(
    (error) => ({
      type: types.CREATE_MANUFACTURED_COMPONENT_ERROR,
      payload: error,
    }),
    'Failed to create component',
  ),
};

export const snapToComponentHeaderRequest = () => ({
  type: types.SNAP_TO_COMPONENT_HEADER_REQUEST,
});

export const openVectorFileEditor = ({
  activeId,
  mode,
  partMasterVersion,
  partUuid,
}) => ({
  type: types.OPEN_VECTOR_FILE_EDITOR,
  payload: { activeId, mode, partMasterVersion, partUuid },
});

export const openVectorEditor = ({ partMasterVersion, partUuid }) => ({
  type: types.OPEN_VECTOR_EDITOR,
  payload: { partMasterVersion, partUuid },
});

export const pageVectorization = {
  request: ({ printPageId, partMasterVersion, partUuid }) => ({
    type: types.PAGE_VECTORIZATION_REQUEST,
    payload: { printPageId, partMasterVersion, partUuid },
  }),
  success: () => ({
    type: types.PAGE_VECTORIZATION_SUCCESS,
  }),
  error: notify(
    (error) => ({
      type: types.PAGE_VECTORIZATION_ERROR,
      payload: error,
    }),
    'Failed to create vectorization',
  ),
};

export const editContours = {
  request: ({ partFileUuid, partMasterVersion, partUuid }) => ({
    type: types.EDIT_CONTOUR_REQUEST,
    payload: { partFileUuid, partMasterVersion, partUuid },
  }),
  success: () => ({
    type: types.EDIT_CONTOUR_SUCCESS,
  }),
  error: notify(
    (error) => ({
      type: types.EDIT_CONTOUR_ERROR,
      payload: error,
    }),
    'Failed to initialize contour edit',
  ),
};

export const switchPrimaryFile = {
  request: ({
    componentId,
    partFileUuid,
    partUuid,
    shouldRegenerateOperations,
    newFilename,
    oldName,
  }) => ({
    type: types.SWITCH_PRIMARY_FILE_REQUEST,
    payload: {
      componentId,
      partFileUuid,
      partUuid,
      shouldRegenerateOperations,
      newFilename,
      oldName,
    },
  }),
  success: notify(
    ({ componentId, newFilename, oldName }) => ({
      type: types.SWITCH_PRIMARY_FILE_SUCCESS,
      payload: { componentId, newFilename, oldName },
    }),
    'Changed primary file',
    ({ payload }) => {
      return `Primary file of ${payload.oldName} was changed to ${payload.newFilename}`;
    },
  ),
  error: notify(
    ({ componentId, error }) => ({
      type: types.SWITCH_PRIMARY_FILE_ERROR,
      payload: { componentId, error },
    }),
    'Unable to change primary file',
    ({ payload }) => payload.error,
  ),
};

export const onBOMRestructure = {
  finish: ({ direction, shouldRefreshQuote }) => ({
    type: types.ON_BOM_RESTRUCTURE,
    payload: { direction, shouldRefreshQuote },
  }),
};
